export const POPULATE_STUDENT_GOALS = 'POPULATE_STUDENT_GOALS';

export const POPULATE_POSSIBLE_STUDENT_CAREER_GOALS =
  'POPULATE_POSSIBLE_STUDENT_CAREER_GOALS';

export const SET_POSSIBLE_STUDENT_CAREER_GOALS_LOADING =
  'SET_POSSIBLE_STUDENT_CAREER_GOALS_LOADING';

export const GET_GOAL_COLLEGES = 'GET_GOAL_COLLEGES';
export const SET_GOAL_COLLEGES = 'SET_GOAL_COLLEGES';
export const CLEAR_GOAL_COLLEGES = 'CLEAR_GOAL_COLLEGES';

export const GET_GOAL_MAJORS = 'GET_GOAL_MAJORS';
export const SET_GOAL_MAJORS = 'SET_GOAL_MAJORS';
export const CLEAR_GOAL_MAJORS = 'CLEAR_GOAL_MAJORS';
